import { loadStripe } from '@stripe/stripe-js'

export const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY)
export const stripePromiseAcheel = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY_ACHEEL)
